<template>
  <div class="modal_wrapper">
    <div class="container">
      <div class="modal_container" :style="{height: contentHeight}">
        <div class="modal_header">
          <img :src="caution" height="25px" />
          {{ confirm }}
        </div>
        <div
          class="modal_body"
          :style="{textAlign: textAlign, height: bodyHeight}"
        >
          <div class="body" v-html="question"></div>
          <div class="modal_buttons">
            <input
              type="button"
              :value="okButton"
              class="finish_button"
              @click="close"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['question'],
  data() {
    return {
      caution: require('../../img/caution.png'),
      confirm: '確認',
      okButton: 'OK'
    }
  },
  computed: {
    contentHeight() {
      if (this.question.length >= 92) {
        return '280px'
      } else if (
        this.question === '追加しました。' ||
        this.question === 'エクスポートしました。' ||
        this.question === 'インポートしました。' ||
        this.question === 'パスワードを初期化しました。' ||
        this.question === 'ダウンロードしました。' ||
        this.question === 'ファイルの検証を開始しました。' ||
        this.question === '送信しました。' ||
        this.question.slice(-7) === '削除しました。' ||
        this.question.slice(-7) === '変更しました。' ||
        this.question.slice(-7) === '更新しました。' ||
        this.question.slice(-10) === 'ログアウトしました。'
      ) {
        return '205px'
      } else {
        return '240px'
      }
    },
    textAlign() {
      if (
        this.question === '追加しました。' ||
        this.question === 'エクスポートしました。' ||
        this.question === 'インポートしました。' ||
        this.question === 'パスワードを初期化しました。' ||
        this.question === 'ダウンロードしました。' ||
        this.question === 'ファイルの検証を開始しました。' ||
        this.question === '送信しました。' ||
        this.question.slice(-7) === '削除しました。' ||
        this.question.slice(-7) === '変更しました。' ||
        this.question.slice(-7) === '更新しました。' ||
        this.question.slice(-10) === 'ログアウトしました。'
      ) {
        return 'center'
      } else {
        return 'left'
      }
    },
    bodyHeight() {
      if (this.question.length >= 92) {
        return '285px'
      } else {
        return '157px'
      }
    }
  },
  methods: {
    close(e) {
      if (this.question.slice(0, 10) === 'MSGCRC0005') {
        // this.$router.push('/Pages')
        // this.$store.dispatch('masters/successLogoutFlag')
        this.$emit('close')
      } else {
        this.$emit('close')
      }
    }
  }
}
</script>
<style scoped>
.modal_wrapper {
  background-color: rgba(0, 0, 0, 0.5);
}
.container {
  display: table-cell;
  vertical-align: middle;
}
.body {
  width: 100%;
  height: 117px;
  padding-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/modalWindow/finishModalWindow.vue